module.exports = "/images/ico-jablko.svg?ea10771d31c4cac9b2afe3512dcae7e6";